import { isAxiosError, type ErrorEnvelope } from './api';

export interface ApiError {
  code: string;
  message: string;
  i18nKey: string;
  status: number | null;
}

const FALLBACK: ApiError = {
  code: 'common.internal',
  message: 'Something went wrong.',
  i18nKey: 'errors.common.internal',
  status: null,
};

export function parseApiError(err: unknown): ApiError {
  if (!isAxiosError<ErrorEnvelope>(err)) return FALLBACK;
  const status = err.response?.status ?? null;
  const env = err.response?.data;
  if (env && typeof env === 'object' && 'error' in env) {
    const code = env.error.code || 'common.internal';
    return {
      code,
      message: env.error.message ?? FALLBACK.message,
      i18nKey: `errors.${code}`,
      status,
    };
  }
  if (status === 401) {
    return {
      code: 'auth.unauthenticated',
      message: 'Not signed in.',
      i18nKey: 'errors.auth.unauthenticated',
      status,
    };
  }
  return { ...FALLBACK, status };
}
